<template>

  <div class="contentMainDiv">
		<div class="noticeDiv">
			<b style="font-size:large;">お知らせ</b><br>
			<br>
			<div v-html="notice.contents" style="font-size:large;">

			</div>
		</div>
		<br>
		<div v-show="role == 'IP4'" class="operationDiv" :style="{'width': width}">
		<span style="color:red;">{{message}}</span>
		<input type="button" @click="addCatalog" style="float: right" value="新規登録" class="button">
		<input type="button" @click="refreshCatalog" style="float: right" value="検索" class="button">
		</div>
		<div  v-show="role == 'guest'"><br></div>

		<div class="table" :style="{'max-height':'400px','width': width}">
			<table>
				<thead>
					<tr>
						<th @click="sort('releasedate')">発売月{{sortMarkers['releasedate']}}</th>
						<th @click="sort('remark')">説明{{sortMarkers['remark']}}</th>
						<th @click="sort('orderlimitdate')">注文締切日{{sortMarkers['orderlimitdate']}}</th>
						<th @click="sort('filename')">ファイル名{{sortMarkers['filename']}}</th>
						<th @click="sort('filesize')">サイズ{{sortMarkers['filesize']}}</th>
						<th @click="sort('updatedate')">更新日{{sortMarkers['updatedate']}}</th>

						<th v-show="role == 'IP4'" @click="sort('isrelease')">リリース{{sortMarkers['isrelease']}}</th>
						<th v-show="role == 'IP4'"></th>
						<th v-show="role == 'guest'"></th>
						<th v-show="role == 'IP4'"></th>
					</tr>
				</thead>
				<tbody>
					<tr  v-for="(data) in catalogList" :key="data.id" :style="{'background-color' : data.isrelease == 0 ? '#dcdcdc':'#ffffff' }">
						<td class="tddatemonth">{{ data.releasedate }}</td>
						<td class="tddremark">{{ data.remark }}</td>
						<td class="tddate" >{{ convertDateToDate( data.orderlimitdate ) }}</td>
						<td class="tdfilename" nowrap>{{ data.filename }}</td>
						<td class="tdfilesize">{{ data.filesize }}MB</td>
						<td class="tddate" nowrap>{{ convertDateToDate( data.updatedate ) }}</td>

						<td v-show="role == 'IP4'" class="tdminisortcenter" nowrap><a href="#" @click.prevent.stop="changeRelease( data.id, !data.isrelease )" >{{ data.isrelease == true ? Definition.RELEASE_STATUS[false]:Definition.RELEASE_STATUS[true]}}</a></td>
						<td v-show="role == 'IP4'"  class="tddownload" nowrap><a href="#" @click.prevent.stop="fileDownloadConfirm( data.id, $event )" >ダウンロード</a> <span style="color:red;font-weight:bold;">{{ data.isNew == true ? "New!" : ""}}</span></td>
						<td v-show="role == 'guest'" class="tddownload" nowrap><a href="#" @click.prevent.stop="fileDownloadGuest( data.id, $event )" >ダウンロード</a> <span style="color:red;font-weight:bold;">{{ data.isNew == true ? "New!" : ""}}</span></td>
						<td v-show="role == 'IP4'" class="tdminicenter" nowrap><a href="#" @click.prevent.stop="deleteCatalogConfirm( data.id, $event )" >削除</a></td>
					</tr>
				</tbody>
			</table>
		</div>
		

		
		<InputMsgBox ref="msgBox" v-if="viewComponent == 1" @returnAction="fileDownload" message='ｳｫｰﾀｰﾏｰｸを入力して下さい。
未入力だとﾕｰｻﾞ情報のｳｫｰﾀｰﾏｰｸが使用されます。' btn1Title='ダウンロード' btn2Title='キャンセル' :targetElement=targetElement />


		<MsgBox ref="msgBoxForDel" v-if="viewComponent == 2" @returnAction="deleteCatalog" message='本当に削除しますか?' :targetElement=targetElement />

		<!--<div v-show="isEdit" style="height:320px;width:450px;background:blue;display: flex;align-items: flex-end; border :solid 1px black;position:absolute;  left:  5px; top: 500px; " class="areadiv" cmanOMat="move">-->
			<div v-show="isEdit" style="position:absolute;  left:  800px; top: 275px;border :solid 2px; padding:10px;max-height:260px;width:450px;background:#fff;">
				<EditCatalog v-if="isEdit == true" :id=editId @setIsEdit="setIsEdit" @setMessage="setMessage" @addRegistedCategoryToList = "addRegistedCategoryToList" ref="editCatalogComp"></EditCatalog>
			</div>
		<!--</div>-->
		
		<div v-show="isProgressVisible" ref="progressDiv"  style="border-radius: 5px;border:solid 1px;position:absolute;width:300px;height:140px;background:#f5f5f5" :style="{'top':targetElement == null ? '0' : targetElement.getBoundingClientRect().top + 'px', 'left':targetElement == null ? '0' : targetElement.getBoundingClientRect().left + 'px'}">
		<center>
		ファイルダウンロード中
		<br>

		<circle-progress 
			v-if="isProgressVisible"
			:is-bg-shadow="true"
			:bg-shadow="{
				inset: true,
				vertical: 2,
				horizontal: 2,
				blur: 4,
				opacity: .4,
				color: '#000000'
			}"
			:size='100'
			:show-percent="true"
			:percent=percent
		/>
		</center>
		</div>
	
	</div>

</template>

<script>
import { ref } from 'vue'
import catalogRepository from '../composables/CatalogRepository'
import listSort from '../composables/ListSort'
import { useStore } from 'vuex'
import "vue3-circle-progress/dist/circle-progress.css";
import CircleProgress from "vue3-circle-progress";
import { convertDateToDateMonth, convertDateToDate, convertReturnDataToArray } from "../api/formatUtils";


//import { addCmanEvent } from "../cmanObjMove_v091.js";
import EditCatalog from "../components/EditCatalog";
import InputMsgBox from "../components/InputMsgBox";
import MsgBox from "../components/MsgBox";
import * as Definition from "../api/Definition"

import noticeRepository from '../composables/NoticeRepository'


export default ({
  name: 'CatalogList',
  components: {CircleProgress, EditCatalog, InputMsgBox, MsgBox},
  setup(){
    
    //addCmanEvent()
    
    const editId = ref( -1 )
    const editCatalogComp = ref(null)
    
    const message = ref("")
    
    const isEdit = ref( false )

    const viewComponent = ref(null)
    
    const targetElement = ref(null)
    
    const msgBox = ref(null)
    const msgBoxForDel = ref(null)
    
    const progressDiv = ref(null)
    
    //ダウンロード時のカタログID保管
    const downloadCatalogId = ref(0)
    
    //削除時のカタログID保管
    const delCatalogId = ref(0) 
    
    //リリース状態更新時のカタログID保管
    const updReleaseCatalogId = ref(0) 
    
    const catalogList = ref([])
    
    const { getCatalog, downloadCatalogFile, updateRelease, deleteCatalogById } = catalogRepository()

    const sortMarkers = ref({releasedate:'',filename:'',filesize:'',updatedate:'',remark:'', isrelease:'', orderlimitdate:''})
    

    //お知らせ情報取得
    const notice = ref({id:"",contents:""})
    const { getLatestNotice } = noticeRepository()
    
    const callbackNotice = ( result, data ) =>{
      if( result == "success" ){
        notice.value = data
        
        notice.value.contents = notice.value.contents.replace(/\n/g, '<br>');
      }
    }
    
    notice.value = getLatestNotice( callbackNotice )
    
    //ソート用メソッド
    const { sort } = listSort( catalogList, sortMarkers )
    
    //ルータ使用変数宣言
    //const router = useRouter()

    //Vuex使用変数宣言
    const store = useStore()
    const role = store.state.role
    
    const isProgressVisible = ref(false)
    
    
    //guest,IP4でテーブルの項目数が違うのでサイズ切り替え
    const width = ref(0)
    if( role == "IP4" ){
      width.value = "1400px"
    }else{
      width.value = "1280px"
    }
    
    
    //新規作成ボタン押下時の処理
    const addCatalog = () => {
      editId.value = null
      isEdit.value = true
    }
    
    
    //編集ボタン押下時の処理
    const editCatalog = ( id ) => {
      editId.value = id
      if(isEdit.value) {
        isEdit.value = false
      }else{
        isEdit.value = true
      }
      if( editCatalogComp.value != null ){
        editCatalogComp.value.$nextTick(() => {
          isEdit.value = true
        })
      }
    }
    
    //削除確認ボックス表示
    const deleteCatalogConfirm = (id, e)=>{
    console.log( msgBoxForDel )
      targetElement.value = e.target
      delCatalogId.value = id

      if( viewComponent.value != 2 ){
        viewComponent.value = 2
      }else{
         viewComponent.value = 0
         if( msgBoxForDel.value != null ){
           msgBoxForDel.value.$nextTick(() => {
             viewComponent.value = 1
           })
         }
      }
    }
    
    //削除処理 ここで削除決定確認結果も行う
    const deleteCatalog = ( confirmRes ) =>{
      viewComponent.value = 0
      if( confirmRes == msgBoxForDel.value.MSG_BOX_OK){
        deleteCatalogById( delCatalogId.value, deleteCatalogCallback)
      }else{
        delCatalogId.value = 0
      }
    }
    //削除処理コールバック
    const deleteCatalogCallback = ( result, id )=>{
      if( result != "success"){
        message.value = result
      }else{
        message.value = "削除完了"
        //削除されたデータをリストから削除
        catalogList.value = catalogList.value.filter( c => c.id != id )
      }
      
      
    }

    
    //公開・非公開切り替え処理
    const changeRelease = ( id, releaseStatus ) => { 
      updReleaseCatalogId.value = id
      updateRelease( id, releaseStatus, callbackChangeRelease )
    }

    //公開・非公開切り替え処理コールバック
    const callbackChangeRelease = ( result, id )=>{
      if( result != "success"){
        message.value = result
      }else{
        message.value = "リリース切替完了"
      }
      
      var cata = catalogList.value.find( c => c.id == id )
      cata.isrelease = !cata.isrelease
    }

    //検索処理
    const refreshCatalog = ()=>{
      message.value = ""
      getCatalog( callback )
    }    

    //データ取得時のコールバック
    const callback = ( result, data )=>{
      if( result != "success"){
        message.value = result
      }else{
        message.value = "データ取得完了"
        catalogList.value = data
        
        if( catalogList.value != null && catalogList.value.length != 0 ){
          catalogList.value.sort( 
            ( a,b )=> {
              return new Date(b.updatedate).getTime() - new Date(a.updatedate).getTime();
            }
          )[0]["isNew"] = true
        }
      }
    }
    
    //ダウンロード確認ボックス表示
    const fileDownloadConfirm = (id, e)=>{
      if( viewComponent.value != 1){
        viewComponent.value = 1
      }else{
         viewComponent.value = 0
         if( msgBox.value != null ){
           msgBox.value.$nextTick(() => {
             viewComponent.value = 1
           })
         }
      }    
      targetElement.value = e.target
      downloadCatalogId.value = id
    }

    
    
    
    /////////////////////////////////////////////////////////////////////////////
    let percent = ref(0)
    //IP4用のファイルダウンロード処理
    const fileDownload = ( confirmRes,value ) => {
      viewComponent.value = 0
      if( confirmRes == msgBox.value.MSG_BOX_OK){
        console.log("id:" + downloadCatalogId.value )
        downloadCatalogFile( downloadCatalogId.value, value, callbackDownloadFile, callbackDownloadFileProgress )
        percent.value = 0
        isProgressVisible.value = true

      }else{
        downloadCatalogId.value = 0
      }
    }
    
    //Guest用のファイルダウンロード処理
    const fileDownloadGuest = (id, e) =>{
        targetElement.value = e.target
        downloadCatalogFile( id, "", callbackDownloadFile, callbackDownloadFileProgress )
        isProgressVisible.value = true
        percent.value = 0
    }
    
    //ダウンロード時の進捗コールバック
    const callbackDownloadFileProgress = ( result ) => {
        console.log( "total:" + result.total )
        console.log( "progress:" + result.loaded )
        
        percent.value =  Math.floor( result.loaded / result.total * 100 )
    }
    
    //ダウンロードのコールバック
    const callbackDownloadFile = ( result ) => {
      isProgressVisible.value = false
      percent.value = 0
      
      progressDiv.value.$nextTick(() => {
        if( result == "success" ){
          message.value = "ファイルダウンロード完了"
        }else{
          var data = result.response.data
          var datas = convertReturnDataToArray( data )
          if( datas[0].startsWith("Error")){
            message.value = datas[1]
          }else{
            message.value = result
          }
       }
     })
    }  
      

    
    const setIsEdit = ( value ) =>{
      console.log("setIsEdit")
      isEdit.value = value
    }
    ////////////////////////////////////////////////////////////////////////////////
    
    //登録したカテゴリをリストにセット、EditCatalogから呼ばれる
    const addRegistedCategoryToList = ( data ) =>{
      catalogList.value.unshift( data )
      
      if (catalogList.value.length == 1){
        catalogList.value[0]["isNew"] = true
        return
      }
      
      catalogList.value.find( c=> c.isNew == true ).isNew = false
      
      catalogList.value.sort( 
          ( a,b )=> {
            return new Date(b.updatedate).getTime() - new Date(a.updatedate).getTime();
          }
      )[0]["isNew"] = true
    }
    
    const setMessage = ( msg ) =>{
      message.value = msg
    }
    
    
    getCatalog( callback )
    
    //template上で使用する変数を宣言
    return{
      catalogList,
      addCatalog,
      getCatalog,
      sort,
      fileDownload,
      percent,
      isProgressVisible,
      convertDateToDateMonth,
      convertDateToDate,
      isEdit,
      editId,
      setIsEdit,
      editCatalog,
      editCatalogComp,
      message,
      fileDownloadConfirm,
      targetElement,
      msgBox,
      msgBoxForDel,
      role,
      fileDownloadGuest,
      Definition,
      changeRelease,
      addRegistedCategoryToList,
      setMessage,
      deleteCatalogConfirm,
      deleteCatalog,
      viewComponent,
      refreshCatalog,
      notice,
      sortMarkers,
      width,
      progressDiv
    }
  }
})

</script>

